module.exports = __webpack_public_path__ + "img/landslide.7ece2737.png";